import { useState } from "react";
import { apiPostRequest } from "../../Helpers/Requests";

export function useImageUpload(uploadEndpoint, onSuccess, onError) {
  const [isUploading, setIsUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  const uploadFile = async (file, resetInput) => {
    const formData = new FormData();
    formData.append("file", file);

    setIsUploading(true);

    try {
      const res = await apiPostRequest(uploadEndpoint, formData, {
        "Content-Type": "multipart/form-data",
      });

      const url = res?.data?.imageUrl ?? res?.data?.image_url;
      if (url) {
        setImageUrl(url);
        onSuccess?.(url);
      }
    } catch (err) {
      onError?.("Failed to upload image");
    } finally {
      setIsUploading(false);
      if (resetInput) resetInput(); 
    }
  };

  return {
    isUploading,
    imageUrl,
    uploadFile,
  };
}
